import React, { Component } from 'react';
import {
    Page,
    Layout,
    Banner,
    Card,
    LegacyStack,
    Button,
    Text,
    Badge,
    ProgressBar,
} from '@shopify/polaris';
import { SkeletonPageCustom } from './SkeletonPageCustom';
import { fetchApi } from './helpers/fetchApi';
import '../modern.css';


export class Onboarding extends Component {
    constructor(props) {
        super(props);
        props.setIsLoading(true);
        this.state = { loading: true, step: 1, isEnableAppEmbedBtnClicked: false, isAppEmbedEnabled: false, isProcessing: false };
    }

    componentDidMount() {
        this.populateData();
    }

    nextStep = () => {
        this.setState((prev) => ({ step: Math.min(prev.step + 1, 4) }));
    };
    goToDashboard = async () => {
        const response = await fetchApi('api/home/SaveOnboardingStatus?status=2', { method: 'post', headers: { 'Content-Type': 'application/json' } });

        this.props.navigate('/plans');
    }
    goToDashboardCompletion = async () => {
        const response = await fetchApi('api/home/SaveOnboardingStatus?status=1', { method: 'post', headers: { 'Content-Type': 'application/json' } });

        this.props.navigate('/plans');
    }
    needHelp = () =>  
    {
        window.open("https://intercom.help/codeinero-help_articles/en/articles/5650971-enable-disable-sticky-add-to-cart", '_blank');
    }
    enableAppEmbed = async () => {
        if (!this.state.isEnableAppEmbedBtnClicked) {
            window.open("https://" + window.shopify.config.shop + "/admin/themes/current/editor?context=apps&&template=product&activateAppId=2d1e1d5d-e947-4201-9a4f-8b73ff50f821%2Fsatcb/app-embed", '_blank');
            this.setState({ isEnableAppEmbedBtnClicked: true })
        } else {
            this.setState({ isProcessing: true });
            const response = await fetchApi('api/home/AppEmbedStatus');
            const data = await response.json();
            if (data !== this.state.isAppEmbedEnabled)
            {
                this.setState({ isAppEmbedEnabled: data });
            }
            this.setState({ isProcessing: data }); // if success keep the check status button disabled
        }
    }


    prevStep = () => {
        this.setState((prev) => ({ step: Math.max(1, prev.step - 1) }));
    };

    renderStepContent() {
        const { step } = this.state;

        // STEP 1: Welcome
        if (step === 1) {
            return (
                <Card sectioned>
                    <LegacyStack vertical alignment="center" spacing="extraLoose">
                        <div style={{ textAlign: 'center' }}>
                            <img
                                src="/images/sticky-addtocart-booster-pro.png"
                                alt="STKY - Sticky add to cart bar"
                                width="96"
                                height="96"
                            />
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <Text variant="headingMd" as="h2">
                                Welcome to STKY - Sticky add to cart bar!
                            </Text>
                            <p style={{ marginTop: 6, color: '#666' }}>
                                Complete the required setup steps to get started.
                            </p>
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <LegacyStack spacing="tight" distribution="center">
                                <Button onClick={this.goToDashboard}>Skip</Button>
                                <Button primary onClick={this.nextStep}>
                                    Start setup
                                </Button>
                            </LegacyStack>
                        </div>
                    </LegacyStack>
                </Card>
            );
        }

        // STEP 2: Theme Extension
        if (step === 2) {
            return (
                <Card sectioned>
                    <LegacyStack vertical spacing="loose">
                        <LegacyStack distribution="equalSpacing" alignment="center">
                            <div>
                                <Text variant="headingSm" as="h3">
                                    Theme extension {this.state.isAppEmbedEnabled ? <Badge status="success">Active</Badge> : <></> }
                                </Text>
                                <p style={{ marginTop: 8 }}>
                                    Please activate the STKY theme app extension in your store's theme
                                    editor now.
                                </p>
                                <div style={{ marginTop: 16 }}>
                                    <LegacyStack spacing="tight">
                                        <Button disabled={this.state.isProcessing} onClick={this.enableAppEmbed}>{this.state.isEnableAppEmbedBtnClicked === false ? 'Enable app embed' : 'Check status'}</Button>
                                        <Button onClick={this.needHelp}>Need help?</Button>
                                    </LegacyStack>
                                </div>
                            </div>

                            <div>
                                <img
                                    src="/images/STKY-Installation-bg.png"
                                    alt="Theme extension"
                                    width="130"
                                />
                            </div>
                        </LegacyStack>

                        {/* Navigation Buttons - centered */}
                        <div style={{ marginTop: 20, textAlign: 'center' }}>
                            <LegacyStack spacing="tight" distribution="center">
                                <Button onClick={this.prevStep}>Back</Button>
                                <Button primary onClick={this.nextStep}>
                                    Next
                                </Button>
                            </LegacyStack>
                        </div>
                    </LegacyStack>
                </Card>
            );
        }

        // STEP 3: Placeholder (sticky content)
        if (step === 3) {
            return (
                <Card sectioned>
                    <LegacyStack vertical alignment="center" spacing="loose">
                        {this.props.sticky}

                        <div style={{ marginTop: 20, textAlign: 'center' }}>
                            <LegacyStack spacing="tight" distribution="center">
                                <Button onClick={this.prevStep}>Back</Button>
                                <Button primary onClick={this.nextStep}>Next</Button>
                            </LegacyStack>
                        </div>
                    </LegacyStack>
                </Card>
            );
        }

        // STEP 4: Completion
        if (step === 4) {
            return (
                <Card sectioned>
                    <LegacyStack vertical alignment="center" spacing="loose">
                        <div style={{ textAlign: 'center' }}>
                            <Text variant="headingMd" as="h2">
                                🎉 Congratulations on completing the setup!
                            </Text>
                            <img
                                src="/images/STKY_onboarding_completed2.png"
                                alt="STKY - Sticky add to cart bar"
                                style={{width:'100%',marginTop:'10px'} }
                            />
                        </div>

                        <div style={{ textAlign: 'center', marginTop: 16 }}>
                            <Button primary onClick={this.goToDashboardCompletion}>
                                Go to homepage
                            </Button>
                        </div>
                    </LegacyStack>
                </Card>
            );
        }

        return null;
    }

    render() {
        const { step, loading } = this.state;
        const totalSteps = 4;
        const progress = (step / totalSteps) * 100;

        return loading ? (
            <SkeletonPageCustom />
        ) : (
            <Page>
                <div className="modern-onboarding">
                <Layout>
                        <Layout.Section>
                            <LegacyStack distribution="trailing">

                            <Button onClick={this.goToDashboard}>
                                Exit onboarding
                                </Button>
                            </LegacyStack>

                        </Layout.Section>

                    <Layout.Section>
                        <div style={{ padding: '12px 0' }}>
                            <ProgressBar progress={progress} size="small" />
                        </div>
                    </Layout.Section>

                    <Layout.Section>{this.renderStepContent()}</Layout.Section>
                </Layout>
                </div>
            </Page>
        );
    }

    async populateData() {
        this.props.setIsLoading(false);
        this.setState({ loading: false });
    }
}
